import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type NewTermSchoolClassState = {
    isLoading: boolean;
    data: NewTermSchoolClass | undefined;
};

export const useViewNewTermSchoolClass = () => {
    const [state, setState] = useState<NewTermSchoolClassState>({
        isLoading: false,
        data: undefined,
    });

    const newTermSchoolClassSettingViewConnection = useAppSelector(
        (state) => state.newTermSchoolClassSettingViewConnection
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = newTermSchoolClassSettingViewConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState({
                    data: dataConvert(payload.result),
                    isLoading: false,
                });
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newTermSchoolClassSettingViewConnection]);

    const request = useCallback(() => {
        dispatch(Actions.http.connection.newTermSchoolClassSetting.view());

        setState((state) => ({
            ...state,
            isLoading: true,
        }));
    }, [dispatch]);

    const reset = useCallback(() => {
        setState((state) => ({
            ...state,
            isLoading: false,
        }));
    }, []);

    return [state, request, reset] as const;
};

type ResponseResult = Http.Connection.Response.NewTermSchoolClassSetting.View['result'];

const dataConvert = (newTermSchoolClassSetting: ResponseResult): NewTermSchoolClass => {
    return {
        uuid: newTermSchoolClassSetting.uuid,
        visibilityTiming: newTermSchoolClassSetting.visibility_timing,
        visibilityScheduledMonth: newTermSchoolClassSetting.visibility_scheduled_month,
        visibilityScheduledDay: newTermSchoolClassSetting.visibility_scheduled_day,
        createdAt: newTermSchoolClassSetting.created_at,
        updatedAt: newTermSchoolClassSetting.updated_at,
    };
};
